<template>
  <b-card no-body class="border-0">
    <b-card-body class="p-0">
      <h5 class="mb-3 text-muted text-uppercase font-weight-bold small"><i class="fa fa-gift"></i> Staff Rewards</h5>

      <b-row>
        <b-col md="6">
          <b-form-group class="mb-3">
            <b-input-group prepend="Credits">
              <b-form-input
                id="staff-credits"
                type="number"
                :readonly="!hasPermission(UserStaffRewardsEdit)"
                v-model="staffCredits"
              />
              <b-input-group-append>
                <b-button
                  variant="primary"
                  :disabled="!hasPermission(UserStaffRewardsEdit) || servers[userData.server].readonly || userLock || !staffCreditsChanged"
                  @click="changeStaffCredits"
                >
                  Change
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group class="mb-3">
            <b-input-group prepend="Tokens">
              <b-form-input
                id="staff-tokens"
                type="number"
                :readonly="!hasPermission(UserStaffRewardsEdit)"
                v-model="staffTokens"
              />
              <b-input-group-append>
                <b-button
                  variant="primary"
                  :disabled="!hasPermission(UserStaffRewardsEdit) || servers[userData.server].readonly || userLock || !staffTokensChanged"
                  @click="changeStaffTokens"
                >
                  Change
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="6">
          <b-form-group class="mb-3">
            <b-input-group prepend="Active Months">
              <b-form-input
                id="active-months"
                type="number"
                :readonly="!hasPermission(UserStaffRewardsEdit)"
                v-model="activeStaffMonths"
              />
              <b-input-group-append>
                <b-button
                  variant="primary"
                  :disabled="!hasPermission(UserStaffRewardsEdit) || servers[userData.server].readonly || userLock || !activeStaffMonthsChanged"
                  @click="changeStaffActiveMonths"
                >
                  Change
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group class="mb-3">
            <b-input-group prepend="Old Months">
              <b-form-input
                id="old-months"
                type="number"
                :readonly="!hasPermission(UserStaffRewardsEdit)"
                v-model="oldStaffMonths"
              />
              <b-input-group-append>
                <b-button
                  variant="primary"
                  :disabled="!hasPermission(UserStaffRewardsEdit) || servers[userData.server].readonly || userLock || !oldStaffMonthsChanged"
                  @click="changeStaffOldMonths"
                >
                  Change
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import VueNotifications from 'vue-notifications'

export default {
  name: 'StaffRewards',
  props: ['userData', 'userLock', 'servers'],

  data () {
    return {
      staffCredits: this.userData.staff_credits,
      staffTokens: this.userData.staff_tokens,
      activeStaffMonths: this.userData.active_staff_months,
      oldStaffMonths: this.userData.old_staff_months
    }
  },

  computed: {
    ...mapGetters(['userError']),
    staffCreditsChanged () {
      return Number(this.staffCredits) !== Number(this.userData.staff_credits)
    },
    staffTokensChanged () {
      return Number(this.staffTokens) !== Number(this.userData.staff_tokens)
    },
    activeStaffMonthsChanged () {
      return Number(this.activeStaffMonths) !== Number(this.userData.active_staff_months)
    },
    oldStaffMonthsChanged () {
      return Number(this.oldStaffMonths) !== Number(this.userData.old_staff_months)
    }
  },

  watch: {
    userData (value) {
      this.staffCredits = value.staff_credits
      this.staffTokens = value.staff_tokens
      this.activeStaffMonths = value.active_staff_months
      this.oldStaffMonths = value.old_staff_months
    },
    'userData.staff_credits' (value) {
      this.staffCredits = value
    },
    'userData.staff_tokens' (value) {
      this.staffTokens = value
    },
    'userData.active_staff_months' (value) {
      this.activeStaffMonths = value
    },
    'userData.old_staff_months' (value) {
      this.oldStaffMonths = value
    },
    userError: function (val) {
      if (val.error === 1) {
        this.ChangeSuccessful()
        this.$emit('refresh')
      } else if (val.error === 2) {
        this.UserOnline()
      }
      this.setLock(false)
    },
    userLock: function (val) {
      if (!val) {
        // Fallback to ensure refresh if lock is released but no error packet received
        // or just to stay in sync
      }
    }
  },

  methods: {
    changeStaffCredits () {
      if (!this.staffCreditsChanged) {
        return
      }
      this.setLock(true)
      this.emit('change_staff_credits', {
        id: this.userData.id,
        value: Number(this.staffCredits),
        server: this.userData.server
      })
    },
    changeStaffTokens () {
      if (!this.staffTokensChanged) {
        return
      }
      this.setLock(true)
      this.emit('change_staff_tokens', {
        id: this.userData.id,
        value: Number(this.staffTokens),
        server: this.userData.server
      })
    },
    changeStaffActiveMonths () {
      if (!this.activeStaffMonthsChanged) {
        return
      }
      this.setLock(true)
      this.emit('change_active_staff_months', {
        id: this.userData.id,
        value: Number(this.activeStaffMonths),
        server: this.userData.server
      })
    },
    changeStaffOldMonths () {
      if (!this.oldStaffMonthsChanged) {
        return
      }
      this.setLock(true)
      this.emit('change_old_staff_months', {
        id: this.userData.id,
        value: Number(this.oldStaffMonths),
        server: this.userData.server
      })
    },
    ...mapActions(['setLock'])
  },
  notifications: {
    ChangeSuccessful: {
      type: VueNotifications.types.success,
      title: 'Change successful!',
      message: 'Change was successful!'
    },
    UserOnline: {
      type: VueNotifications.types.error,
      title: 'Change failed!',
      message: 'User is online! Please wait until the user is offline.'
    }
  }
}
</script>
